/**
 * user-profile-validation.js
 */


const validEmailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export const isValidEmail = (email) => {
  return String(email).toLowerCase().match(validEmailPattern);
};


export const emailValidationRules = (requiredError, patternError, lengthError) => {
  return {
    required: requiredError ?? 'Please enter a valid email',
    pattern: {
      value: validEmailPattern,
      message: patternError ?? 'Please enter a valid email'
    },
    maxLength: {
      value: 200,
      message: lengthError ?? 'Maximum length is 200 chars'
    }
  };
};


export const passwordValidationRules = (allowEmpty, requiredError, patternError, minLengthError, maxLengthError) => {
  return {
    validate: (value) => {
      if (!allowEmpty && !value) {
        return requiredError ?? 'Please enter a password';
      } else if (value && value.length < 8) {
        return minLengthError ?? 'Your password must be at least 8 characters in length';
      } else if (value && value.length > 20) {
        return maxLengthError ?? 'Your password must be less than 20 characters in length';
      } else if (value && !/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}$/.test(value)) {
        return patternError ?? 'The password must contain an uppercase letter, a lowercase letter and a number.';
      } else {
        return true;
      }
    }
  };
}


export const passwordConfirmValidationRules = (allowEmpty, passwordValue, requiredError, mismatchError) => {
  return {
    validate: (value) => {
      if (!allowEmpty && !value) {
        return requiredError ?? 'Please confirm your password';
      } else if (value && value !== passwordValue) {
        return mismatchError ?? 'Passwords do not match';
      } else {
        return true;
      }
    }
  }
}


export const firstNameValidationRules = (requiredError, lengthError) => {
  return {
    required: requiredError ?? 'Please enter a first name',
    validate: value => value.trim() !== '' || (requiredError ?? 'Please enter a first name'),
    maxLength: {
      value: 50,
      message: lengthError ?? 'Maximum length is 50 chars'
    }
  };
}


export const lastNameValidationRules = (requiredError, lengthError) => {
  return {
    required: requiredError ?? 'Please enter a last name',
    validate: value => value.trim() !== '' || (requiredError ?? 'Please enter a last name'),
    maxLength: {
      value: 50,
      message: lengthError ?? 'Maximum length is 50 chars'
    }
  };
}


export const phoneValidationRules = (lengthError) => {
  return {
    maxLength: {
      value: 15,
      message: lengthError ?? 'Maximum length is 15 chars'
    }
  };
}


export const departmentNameValidationRules = (requiredError, lengthError) => {
  return {
    required: requiredError ?? 'Please enter a department name',
    validate: value => value.trim() !== '' || (requiredError ?? 'Please enter a department name'),
    maxLength: {
      value: 250,
      message: lengthError ?? 'Maximum length is 250 chars'
    }
  };
}


export const badgeValidationRules = (requiredError, lengthError) => {
  return {
    required: requiredError ?? 'Please enter a badge',
    validate: value => value.trim() !== '' || (requiredError ?? 'Please enter a badge'),
    maxLength: {
      value: 250,
      message: lengthError ?? 'Maximum length is 250 chars'
    }
  };
}


export const dutyValidationRules = (lengthError) => {
  return {
    maxLength: {
      value: 250,
      message: lengthError ?? 'Maximum length is 250 chars'
    }
  };
}